<template>
  <div class="kpi-direction-message-in-header">
    <FavorabilityIcon
      :less_is_better="less_is_favorable"
      :size="24"
      color="Grey"
    />
    <span class="message">{{ messageText }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import FavorabilityIcon from '@components/FavorabilityIcon/FavorabilityIcon.vue';
import {
  FAVORABILITY_COPY,
  LESS_IS_FAVORABLE,
  MORE_IS_FAVORABLE,
} from '@components/constants/favorability';

const props = defineProps({
  less_is_favorable: {
    type: Boolean,
    default: false,
  },
});

const messageText = computed(
  () => FAVORABILITY_COPY[props.less_is_favorable ? LESS_IS_FAVORABLE : MORE_IS_FAVORABLE].label
);
</script>

<style scoped>
.kpi-direction-message-in-header {
  width: 247px;
  height: 106px;
  box-sizing: border-box;
  border: 1px dashed var(--stroke-not-selcted, #eaecf0);
  border-radius: 5px;
  background-color: var(--white, #ffffff);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}

.message {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #98A2B3;
}

.kpi-direction-message-in-header :deep(svg path) {
  fill: #6F6F6F;
}
</style>
